var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8 7.14663V18.2247C19.8 20.0183 18.37 21.3899 16.5 21.3899H4.29015C4.29015 22.5504 5.28014 23.5 6.49013 23.5H17.6C20.02 23.5 22 21.6009 22 19.2798V9.25674C22 8.09618 21.01 7.14663 19.8 7.14663Z",
    fill: "#5D5D5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.29997 0.5V2.61011H2.19998C0.989992 2.61011 0 3.55966 0 4.72023V17.3809C0 18.5415 0.989992 19.491 2.19998 19.491H15.6199C16.8299 19.491 17.8199 18.5415 17.8199 17.3809V4.72023C17.8199 3.55966 16.8299 2.61011 15.6199 2.61011H14.5199V0.5H12.3199V2.61011H5.49996V0.5H3.29997ZM2.19998 7.8854H15.6199V17.3809H2.19998V7.8854Z",
    fill: "#5D5D5D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8697 16.5367L10.2298 15.0596L7.69978 16.5367L8.35978 13.6881L6.04979 11.789L9.12977 11.578L10.3398 8.83481L11.5497 11.4725L14.6297 11.789L12.3197 13.6881L12.8697 16.5367Z",
    fill: "#5D5D5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector3);
export default __webpack_public_path__ + "static/media/Vector_3.c24467f3ffc1b4779083b8f2c26b7734.svg";
export { ForwardRef as ReactComponent };